var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.384 39.905c0-3.728 2.82-6.73 6.32-6.73s6.32 3 6.32 6.73V56.47c0 3.728-2.82 6.73-6.32 6.73s-6.32-3.002-6.32-6.73z",
    stroke: "#e01e5a",
    fill: "#e01e5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.906 45.827c-3.728 0-6.73-2.82-6.73-6.32s3-6.32 6.73-6.32h16.565c3.728 0 6.73 2.82 6.73 6.32s-3 6.32-6.73 6.32z",
    stroke: "#ecb22d",
    fill: "#ecb22d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.186 6.73c0-3.728 2.82-6.73 6.32-6.73s6.32 3 6.32 6.73v16.575c0 3.728-2.82 6.73-6.32 6.73s-6.32-3-6.32-6.73z",
    stroke: "#2fb67c",
    fill: "#2fb67c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.731 30.025c-3.728 0-6.73-2.82-6.73-6.32s3-6.32 6.73-6.32h16.575c3.728 0 6.73 2.82 6.73 6.32s-3 6.32-6.73 6.32z",
    stroke: "#36c5f1",
    fill: "#36c5f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.186 56.889a6.31 6.31 0 0 0 6.321 6.321 6.31 6.31 0 0 0 4.474-10.795 6.31 6.31 0 0 0-4.474-1.847h-6.32z",
    stroke: "#ecb22d",
    fill: "#ecb22d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89 30.025h-6.32v-6.32a6.32 6.32 0 0 1 9.482-5.474 6.32 6.32 0 0 1 3.16 5.474 6.31 6.31 0 0 1-6.321 6.321z",
    stroke: "#2fb67c",
    fill: "#2fb67c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.322 33.185h6.32v6.32a6.31 6.31 0 0 1-6.321 6.321A6.31 6.31 0 0 1 0 39.505a6.31 6.31 0 0 1 6.321-6.321z",
    stroke: "#e01e5a",
    fill: "#e01e5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.026 6.321v6.32h-6.32a6.31 6.31 0 0 1-6.321-6.321A6.31 6.31 0 0 1 23.705 0a6.31 6.31 0 0 1 6.321 6.321z",
    stroke: "#36c5f1",
    fill: "#36c5f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.9e3483fcc148e7d394a7e8b367a3c694.svg";
export { ForwardRef as ReactComponent };